exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".history-log-and-memo[data-v-e256a016]{width:100%;height:186px;font-size:.9rem;display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;border:1px solid #ddd;border-radius:3px;padding:12px;overflow-y:auto}.history-memo-item[data-v-e256a016]{width:100%;margin-bottom:12px}", ""]);

// exports
